import "./ResetPassword.css";
import { useState } from "react";
import { GeneralFooter, MooringMateHomeHeader } from "../../../components";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { validateEmail, validatePassword } from "../../../utils";
import toast from "react-hot-toast";
import Container from "@mui/material/Container";
import CircularProgress from "@mui/material/CircularProgress";
import { resetPassword } from "../../../services/auth";

export const ResetPassword = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  let [searchParams] = useSearchParams();
  let token = searchParams.get("t");

  const handleChange = (target) => {
    const { name, value } = target;
    setData({ ...data, [name]: value });
    return;
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleFocusOut = (e) => {
    if (e.target.name === "userName" && !validateEmail(e.target.value)) {
      setErrorField("userName");
      return;
    } else {
      setErrorField("");
    }

    if (e.target.name === "password" && !validatePassword(e.target.value)) {
      setErrorField("password");
      return;
    }
    setErrorField("");
    return;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(data.userName) || !validatePassword(data.password)) {
      toast.error("Please provide a valid email and password");
      return;
    }

    if(data.password !== confirmPassword) {
      setConfirmPasswordError(true);
      toast.error("Passwords do not match");
      return;
    }

    setLoading(true);
    const res = await resetPassword(data, token);

    if (res?.status === true) {
      toast.success(res.message);
      setLoading(false);
      navigate("/login");
      return;
    }

    toast.error(res?.message);
    setLoading(false);
    return;
  };

  return (
    <>
      <MooringMateHomeHeader />
      <div className="reset-wrapper top-section">
        <Container maxWidth="xl">
          <div className="reset-password-content">
            <h1 className="title">Reset your password</h1>
            {token ? (
              <form onSubmit={handleSubmit} className="formInputContainer">
                <TextField
                  required
                  name="userName"
                  label="Enter your email"
                  type="email"
                  size="small"
                  fullWidth
                  value={data.userName || ""}
                  onChange={(e) => handleChange(e.target)}
                  onBlur={(e) => handleFocusOut(e)}
                  error={errorField === "userName"}
                  helperText={
                    errorField === "userName" &&
                    "Please enter a valid email address"
                  }
                />
                <TextField
                  required
                  name="password"
                  label="Enter your new password"
                  type={showPassword ? "text" : "password"}
                  size="small"
                  fullWidth
                  value={data.password || ""}
                  onChange={(e) => handleChange(e.target)}
                  onBlur={(e) => handleFocusOut(e)}
                  error={errorField === "password"}
                  helperText={
                    errorField === "password" &&
                    "Password must be at least 8 characters and include at least one uppercase, one lowercase, one digit and one special character."
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  name="confirmPassword"
                  size="small"
                  required
                  label="Confirm Password"
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  autoComplete="new-password"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    // Clear error when user starts typing
                    if (confirmPasswordError) {
                      setConfirmPasswordError(false);
                    }
                  }}
                  error={confirmPasswordError}
                  helperText={confirmPasswordError && "Passwords do not match"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle confirm password visibility"
                          onClick={handleClickShowConfirmPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  disabled={loading}
                  color="primary"
                  className="theme-btn"
                  sx={{
                    boxShadow: "0 0px 0px 0px rgba(255, 255, 255, .0)!important",
                    height: "50px",
                    borderRadius: "10px",
                  }}
                >
                  {loading ? <CircularProgress size={20} /> : "Reset Password"}
                </Button>
                <Link to="/login" variant="body2" className="link">
                  Back to login
                </Link>
              </form>
            ) : (
              <p style={{ textAlign: 'center', fontSize: '20px' }}>You don't have access to this page</p>
            )}
          </div>
        </Container>
      </div>

      {/* footer */}
      <GeneralFooter />
    </>
  );
};
